import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';

/**
 * 페이지 마운트 시 스크롤을 상단으로 이동
 */
export const useScrollTop = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
};
function _temp() {
  window.scrollTo(0, 0);
}